import { render, staticRenderFns } from "./DiscountParametersWidget.vue?vue&type=template&id=4c2831fd&"
import script from "./DiscountParametersWidget.vue?vue&type=script&lang=js&"
export * from "./DiscountParametersWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports